import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { googleColor } from "../../data/googleColors";
import { useTranslate } from "../../i18n/useTranslate";

export default function MetricCard({ title, value, subtitle, icon, index=0, trend, live=false }) {
  const Icon = Icons[icon] || Icons.Activity;
  const c    = googleColor(index);
  const t    = useTranslate();

  return (
    <motion.div
      initial={{ opacity:0, y:12 }}
      animate={{ opacity:1, y:0 }}
      transition={{ delay: index * 0.06, duration:0.4 }}
      className="rounded-2xl shadow-card card-hover p-4 border"
      style={{ background:c.bgLight, borderColor:c.border }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background:c.bg }}>
          <Icon size={18} style={{ color:c.text }} />
        </div>
        {live && (
          <span className="flex items-center gap-1 text-[9px] font-black text-emerald-700">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 live-dot" />{t("LIVE")}
          </span>
        )}
        {trend !== undefined && !live && (
          <div className={`flex items-center gap-1 text-[10px] font-bold ${trend >= 0 ? "text-emerald-700" : "text-red-700"}`}>
            {trend >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <div className="text-2xl font-black leading-none" style={{ color:c.text }}>{value}</div>
      <div className="text-xs font-semibold mt-1" style={{ color:c.text }}>{t(title)}</div>
      {subtitle && <div className="text-[10px] mt-0.5 opacity-70" style={{ color:c.text }}>{t(subtitle)}</div>}
    </motion.div>
  );
}
